import React from 'react';
import PropTypes from 'prop-types';
import { annotation as annotationConstants } from './../helpers';
import { LocalForm, Control, Errors } from 'react-redux-form';
import SelectComponent from './SelectComponent';
import {
  Modal,
  Button,
  FormGroup,
  ControlLabel
} from 'react-bootstrap';

export default class ChangeCommenterNameModalComponent extends React.Component {
  static propTypes = {
    visible: PropTypes.bool,
    hide: PropTypes.func,
    submit: PropTypes.func,
    scenario: PropTypes.object,
    status: PropTypes.string,
    position: PropTypes.string
  };

  _validateTicket(ticket) {
    if (!ticket) return true;
    const ticketRegex = /^[a-zA-Z]{2,5}-\d{1,5}$/;
    return ticketRegex.test(ticket);
  }

  render() {
    const {
      visible,
      hide,
      scenario,
      submit,
      status,
      position
    } = this.props;

    const statusList = annotationConstants.getScenarioStatusList()
      .map(s => s.displayStatus);

    const initialState = {
      scenario: scenario,
      userName: localStorage.getItem('userName') ? localStorage.getItem('userName') : '',
      position: position,
      status: status,
      ticket: '',
      comment: ''
    };

    return (
      scenario !== undefined && scenario.id !== 0 ?
        <Modal show={visible} onHide={hide}>
          <Modal.Header closeButton>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <LocalForm
            id="add-comment-form"
            validators={{
              '' : {
                ticket: val => {
                  return this._validateTicket(val.ticket);
                }
              }
            }}
            onSubmit={submit}
            onChange={model => {
              this.setState(
                { ...model }
              ); }}
            initialState={initialState}
          >
            <Modal.Body>
              <FormGroup controlId="status">
                <ControlLabel>Status</ControlLabel>
                <Control.custom
                  id="status-input"
                  component={SelectComponent}
                  className="form-control"
                  model="."
                  type="hidden"
                  mapProps={({ modelValue, onChange }) => {
                    let ticket = modelValue.ticket;
                    if (!ticket || this._validateTicket(ticket))
                      ticket = null;
                    return {
                      options: statusList,
                      selected: initialState.status,
                      onChange: d => onChange({
                        ...modelValue,
                        status: d
                      }),
                    };
                  }}
                />
              </FormGroup>
              <FormGroup controlId="userName">
                <ControlLabel>Your Name</ControlLabel>
                <Control
                  id="username-input"
                  className="form-control"
                  model=".userName"
                  type="text"
                  placeholder="Please enter your name."
                  validators={{ userName: val => !!val.length }}
                />
                <Errors
                  className="popover-bottom"
                  model=".userName"
                  show="touched"
                  messages={{ userName: 'Invalid userName' }}
                />
              </FormGroup>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={hide}>Cancel</Button>
              <Button bsStyle="primary" type="submit">{'Comment'}</Button>
            </Modal.Footer>
          </LocalForm>
        </Modal> :
        null
    );
  }
}


// WEBPACK FOOTER //
// src/Components/ChangeCommenterNameModalComponent.jsx